export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "binaryDownloader.worker.9ffd3eed0a66411ddce0.worker.js");
}
